import React from 'react';
import moment from 'moment';

export default function ImportResult({ results, onClose }) {
  const {
    import_total = 0,
    import_errors = [],
    import_created = 0,
    import_updated = 0,
  } = results || {};
  const successTotal = Math.max(import_total - import_errors.length, 0);

  return (
    <div className='bw_modal bw_modal_open' id='bw_store_import_result'>
      <div className='bw_modal_container bw_filter'>
        <div className='bw_title_modal'>
          <h3>Kết quả nhập Excel cửa hàng</h3>
          <span className='bw_close_modal fi fi-rr-cross-small' onClick={onClose}></span>
        </div>
        <div className='bw_main_modal'>
          <div className='bw_box_card bw_mt_1'>
            <div className='bw_row'>
              <div className='bw_col_12 bw_mb_1'>
                <b>Thời gian:</b> {moment().format('DD/MM/YYYY HH:mm')}
              </div>
              <div className='bw_col_12 bw_mb_2'>
                <b>Danh sách cửa hàng đã được xử lý. Kết quả cụ thể như sau:</b>
              </div>
              <div className='bw_col_3 bw_mb_1'>
                <b>Tổng số dòng:</b> {import_total}
              </div>
              <div className='bw_col_3 bw_mb_1'>
                <b>Thành công:</b> <span className='bw_green'>{successTotal}</span>
              </div>
              <div className='bw_col_3 bw_mb_1'>
                <b>Thêm mới:</b> <span className='bw_green'>{import_created}</span>
              </div>
              <div className='bw_col_3 bw_mb_1'>
                <b>Cập nhật:</b> <span className='bw_green'>{import_updated}</span>
              </div>
              <div className='bw_col_12 bw_mb_2'>
                <b>Số dòng lỗi:</b> <span className='bw_red'>{import_errors.length}</span>
              </div>
              <div className='bw_col_12'>
                <div className='bw_table_responsive'>
                  <table className='bw_table'>
                    <thead>
                      <tr>
                        <th>Dòng</th>
                        <th>Mã cửa hàng</th>
                        <th>Tên cửa hàng</th>
                        <th>Địa chỉ</th>
                        <th style={{ width: '45%' }}>Lỗi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {import_errors.length ? (
                        import_errors.map((error, index) => (
                          <tr key={index}>
                            <td>{error.i}</td>
                            <td>{error.item?.store_code}</td>
                            <td>{error.item?.store_name}</td>
                            <td>{error.item?.address}</td>
                            <td style={{ whiteSpace: 'pre-line', width: '45%' }}>
                              <span className='text-danger'>{error.errmsg?.join('\n')}</span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className='bw_text_center'>
                            Không có dòng lỗi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='bw_footer_modal'>
          <button type='button' className='bw_btn bw_btn_success' onClick={onClose}>
            <span className='fi fi-rr-check'></span> Đã hiểu
          </button>
        </div>
      </div>
    </div>
  );
}
